import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';

import React from 'react';
import { DialogTitle } from './DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { pxToRem } from 'src/common/utils/fonts';

export type DialogProps = Pick<MuiDialogProps, 'open' | 'children'> & {
  title: string;
  subtitle?: string;
  size?: 'small' | 'medium' | 'large';
  actions?: React.ReactNode;
  onClose: () => void;
  fullWidth?: boolean;
};

const getDialogMaxWidth = (size: 'small' | 'medium' | 'large') => {
  if (size === 'large') {
    return pxToRem(1350);
  }

  return size === 'medium' ? pxToRem(900) : pxToRem(600);
};

export const Dialog: React.FC<DialogProps> = ({
  title,
  subtitle,
  size = 'large',
  children,
  actions,
  open,
  onClose,
  fullWidth = true,
  ...props
}) => {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      slotProps={{
        paper: {
          sx: {
            maxWidth: getDialogMaxWidth(size),
          },
        },
      }}
      {...props}
    >
      <DialogTitle title={title} subtitle={subtitle} />
      <IconButton
        aria-label="close"
        onClick={() => {
          onClose();
        }}
        sx={{
          position: 'absolute',
          right: '0.281rem',
          top: '0.281rem',
          color: (theme) => theme.palette.text.secondary,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          mt: 8,
          pb: 10,
          pl: 20,
          pr: 48,
          whiteSpace: 'pre-wrap',
        }}
      >
        {children}
      </DialogContent>
      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </MuiDialog>
  );
};
